import React, {useEffect, useState, useRef} from 'react';
import Typography from "@material-ui/core/Typography";
import {
  fetchAPIRequestData,
  getIndividualPageData,
  getPageInfo,
  parseGutenbergReact
} from "../../api/global";
import {entitiesArrayDrupalSidenav} from "../../utils/transforms";
import ContentList from '../../components/02_molecules/ContentList';
import {default as ArticleTemplate} from '../../components/04_templates/Article/Article';
import _ from 'lodash';
import {useForm, Controller} from 'react-hook-form';
import Container from '@material-ui/core/Container';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {makeStyles} from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import {useRouter} from "next/router";

const layoutOpts = {
  titleBgWide: false,
  titleBgClr: "warning.dark",
  mainBgClr: false,
  mainBgImg: false,
  sideBgClr: false,
  topBgClr: "success.main",
  blogBanner: false,
};

const blog_query = {
  'fields[articles]': 'id,internalId,path,title,alias,image,created,body',
  'include': 'image,image.imageFile',
  'fields[images]': 'imageFile',
  'fields[files]': 'uri',
  'sort': '-created',
  'filter[isPublished][value]': 1,
};

const fetchOpts = {
  url: `/api/rest/view/article-all`,
  query: {},
  opts: {type: 'tld', dbview: 'rest'},
};

// This is for resetting back to intial state, non-modifiable:
const form_default_reset = {
  txt: '',
  page: 0,
}

// These are initial settings, but get altered down the road:
let form_default = {
  txt: '',
  page: 0,
}

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.grey[200],
    padding: '1.5rem 0 1rem',
    '& .MuiInput-underline:before': {
      border: 0,
    },
    '& .MuiButton-text': {
      padding: '10px 8px',
    },
    '& .MuiNativeSelect-icon': {
      display: 'none',
    },
    '& ul[role="listbox"]': {
      margin: '0 !important',
    },

  },
  desktopForm: {
    position: 'relative',
  },
  searchInput: {
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
    },
    // [theme.breakpoints.up('md')]: {
    //   maxWidth: 'calc(100vw - 550px)',
    //   // width: '650px',
    // },
    // width: '850px',
    // maxWidth: '100%',
    height: 44,
    border: 0,
    paddingLeft: 16,
    paddingRight: 40,
    backgroundColor: theme.palette.grey[300],
    textTransform: 'uppercase',
  },
  keywordWrapper: {
    position: 'relative',
    "& button": {
      color: theme.palette.success.light,
      [theme.breakpoints.down('sm')]: {
        top: 4,
        right: 4,
      },
      position: 'absolute',
      top: 4,
      right: 4,
      padding: 10,
    }
  },
  resetLink: {
    color: theme.palette.success.light,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  formControl: {
    margin: '0 0 1rem',
  },
  searchTextSubmit: {
    backgroundColor: theme.palette.warning.main,
    // [theme.breakpoints.down('sm')]: {
    //   backgroundColor: theme.palette.warning.main,
    // },
    borderRadius: 0,
  },
}));


export async function getStaticProps(context) {
  let initialProps = {
    statusCode: 200,
  };
  let data, node_data, termsMenu, recentNodes;

  try {
    [data, termsMenu, recentNodes] = await Promise.all([
      getPageInfo(`/blog`),
      fetchAPIRequestData(`/api/rest/view/article-topics`, {}, {type: 'tld'}),
      fetchAPIRequestData(`/articles`, blog_query, {type: 'api'}, 4),
    ]);

    if (data?.page?.entity) {
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
      if (node_data) {
        initialProps = {...initialProps, ...node_data};
      }
    }

    // Merge initially defined props with response from the backend.
    initialProps = {...initialProps, ...data};
    if (!node_data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('BLOG LANDING retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  return {
    props: {
      ...initialProps,
      termsMenu: (termsMenu?.page_data || []),
      recentNodes: (recentNodes?.page_data || [])
    }, // will be passed to the page component as props
    revalidate: 900,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  }
}

export default function BlogLandingPage(props) {
  const router = useRouter();
  const classes = useStyles();
  const node = props.page?.entity || null;
  const meta = props.metatags?.tags;
  let node_data, body, body_json;

  const [resetPager, setResetPager] = useState(null);
  // Query string for browser history:
  const [urlQueryObj, setUrlQueryObj] = useState({
    forceFormUpdate: false,
    q: (typeof window !== "undefined") ? decodeURI(window.location.search)?.slice(1) : null,
  });
  let lq = {};
  const currFormRef = useRef(null);


  if (node && props.page_data) {
    node_data = props.page_data;
    ({body, body_json} = node_data);
  }

  if (props.termsMenu) {
    var terms = entitiesArrayDrupalSidenav(props.termsMenu);
  }

  let {
    handleSubmit,
    control,
    watch,
    resetField,
    reset,
    formState: {errors, isSubmitting, isSubmitted}
  } = useForm({
    defaultValues: form_default
  });

  const [searchQ, setSearchQ] = useState(fetchOpts);

  /* RESET form handler */
  const handleSearchFormReset = (event) => {
    reset(form_default_reset);
    router.push(window.location.origin + window.location.pathname, undefined, {shallow: true});
  };

  /* SUBMIT form handler */
  const onSubmit = async (form_data) => {
    let new_lq = {...fetchOpts};
    new_lq['page'] = 0;

    if (form_data.txt == ''/* && lq['txt']*/) {
      new_lq['query'] = {};
    }
    else if (form_data.txt?.length > 1) {
      new_lq['query'] = {'bterm': form_data.txt};
    }

    // Reset the Pager state so that Search query doesn't include paginated
    // request:
    setResetPager(-1);
    setSearchQ(new_lq);
    // Reset the Pager state so that Pager component is set back to a page
    // state = 0:
    setResetPager(null);
  };

  let debouncedSearch = _.debounce(handleSubmit(onSubmit), 900);
  useEffect(() => {
    const subscription = watch((data, someObj) => {
      debouncedSearch(data, 900);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
      <ArticleTemplate node={node_data} metatags={meta} terms_menu={terms || []}
                       opts={layoutOpts}
                       recent={props.recentNodes.slice(0, 4) || []}>
        {(body_json?.json?.length > 0) &&
        body_json.json.map((block, key) => {
          return parseGutenbergReact(key, block);
        })
        }
        {body?.length > 0 && _.isEmpty(body_json) &&
        <Typography paragraph component={`div`}>
          <div dangerouslySetInnerHTML={{__html: body}}></div>
        </Typography>
        }

        <div className={classes.root}>
          <form noValidate className="search-form" autoComplete="off"
                key={`blog-search-form`}
                onSubmit={handleSubmit(onSubmit)} ref={currFormRef}>
            <Container className={classes.desktopForm}>
              <Grid container spacing={1}>
                <Grid className={classes.keywordWrapper} item xs>
                  <Controller name="txt" control={control}
                              render={({field}) => (
                                  <TextField {...field} id="edit-txt"
                                             disableUnderline={true}
                                             key={`edit-txt`}
                                             inputProps={{maxLength: 100}}
                                             type="text"
                                             className={classes.searchInput}
                                             placeholder="Search articles"
                                             fullWidth
                                  />
                              )}
                  />
                  <div>
                    <IconButton className={classes.searchTextSubmit}
                                name="submit"
                                type="submit"
                                value="Search" aria-label="Search our listings">
                      <SearchIcon/>
                    </IconButton>
                  </div>
                </Grid>
                <Grid item>
                  <Button variant="text" onClick={() => handleSearchFormReset()}
                          color="primary">RESET SEARCH</Button>
                </Grid>
              </Grid>
            </Container>

          </form>
        </div>

        <ContentList perPage={8} fetchOpts={searchQ} pageCurr={resetPager}
                     comp={`EatonTeaserArticle`}/>
      </ArticleTemplate>
  );
}
